import { AxiosError } from 'axios';
import Cookies from 'js-cookie';
import { useLocation, useNavigate } from 'react-router-dom';

import { PageRoutesEnum } from './routes';

export const useHandleHttpErrors = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleHttpErrors = (error: unknown) => {
    const status = (error as AxiosError).response?.status;
    if (status === 401 && location.pathname !== '/consents') {
      Cookies.remove('token');
      navigate(PageRoutesEnum.login);
    }
  };

  return { handleHttpErrors };
};
